export default [
  { label: 'Yearly', value: 'Yearly' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Once Per Two Weeks', value: 'OncePerTwoWeeks' },
];
